import { GoogleAdsConnectionSchema } from "@redotech/redo-integrations-definitions-common/integration/google-ads/google-ads-definition";
import * as z from "zod";

export const getGoogleAdsIntegration = {
  name: "getGoogleAdsIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    customerId: z.string().optional(),
    connections: z.array(GoogleAdsConnectionSchema),
  }),
};
